import type { UseFiltersData } from 'plp/components/Catalog/List/getFiltersData/getFiltersData'
import type { FiltersSearchParams } from 'plp/types/Catalog'
import type { Tag } from 'plp/types/Filters'
import type { CountryConfiguration } from 'types/countryConfiguration'

import { PLPQueryParams } from '../../constants/queryParams'
import { getCurrencyRangeString } from '../../utils/getCurrencyRangeString'
import { ORDER_OPTIONS, RECOMMENDED } from './constants'
import { deserialize } from './serializer/serializer'
import { getFilterId } from './utils'

export function getTagsData(
	defaultFilter: FiltersSearchParams,
	filtersData: UseFiltersData,
	country: CountryConfiguration,
	t: (key: string) => string
): Tag[] {
	const deserializedData = deserialize(defaultFilter)
	const deserializedOptions =
		deserializedData?.options.flatMap((option) => {
			const filter = filtersData.filters.find(
				(found) => getFilterId(found) === option.id
			)
			return option.selection.map((selection) => ({
				type: PLPQueryParams.filters,
				id: option.id,
				label:
					filter?.options.find((current) => current.id === selection)?.label ??
					'',
			}))
		}) ?? []
	const deserializedOrder =
		deserializedData?.order && deserializedData.order !== RECOMMENDED
			? [
					{
						type: PLPQueryParams.order,
						label: t(
							ORDER_OPTIONS.find(
								(orderItem) => orderItem.id === defaultFilter.order
							)?.label ?? ''
						),
					},
				]
			: []

	const tags = [...deserializedOptions, ...deserializedOrder].flat()
	if (deserializedData?.range) {
		const deserializedRange = {
			type: PLPQueryParams.range,
			label: getCurrencyRangeString(deserializedData.range, country, t),
		}
		tags.push(deserializedRange)
	}
	return tags
}
